import state from './state';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';

export default class Behavior {

  constructor(apiUndesirableBehavior) {
    this.namespaced = true;
    this.state = state();
    this.getters = getters;
    this.actions = actions;
    this.mutations = mutations;

    this.state.apiManager = apiUndesirableBehavior;
  }

}




// WEBPACK FOOTER //
// ./src/modules/undesirableBehavior/vuex/index.js